import moment from 'moment'

export const formatData = (repoFiles, key) => {
  const obj = {
    root: []
  }

  key = key && key.toLowerCase()
  repoFiles.forEach(file => {
    const curr = obj

    let last
    let beforeLast

    const splitted = file.Path.split('/')
    const orSplitted = file.fullPath ? file.fullPath.split('/') : file.Path.split('/')

    const lowerCasedPath = splitted.map(name => name.toLowerCase())
    const lowerCasedFullPath = orSplitted.map(name => name.toLowerCase())

    const index = key && lowerCasedPath && lowerCasedPath.length && lowerCasedPath.indexOf(key)

    const item = key
      ? key === 'root'
        ? lowerCasedFullPath[0]
        : index !== -1 ? lowerCasedPath[index] : lowerCasedPath[0]
      : lowerCasedPath[0]

    if (lowerCasedPath.length === 1) {
      beforeLast = 'root'
      last = lowerCasedPath[0]
    } else {
      beforeLast = item

      lowerCasedPath[0] === item ? lowerCasedPath.shift() : lowerCasedPath.splice(0, lowerCasedPath.indexOf(key)+1)

      last = lowerCasedPath.join('/')
    }

    if (!curr[beforeLast]) {
      curr[beforeLast] = []
    }

    const fullPath = lowerCasedFullPath.join('/') || lowerCasedPath.join('/')
    const original = fullPath.replaceAll('/', '\\')

    curr[beforeLast].push({
      Path: last,
      fullPath: fullPath,
      MimeType: file.MimeType,
      selected: false,
      originalPath: original
    })
  })
  return obj
}

export const moveArrayItemToNewIndex = (arr, oldIndex, newIndex) => {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1
    while (k--) {
      arr.push(undefined)
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
  return arr
}

export const bytesToSize = (bytes) => {
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  for (let i = 0; i < sizes.length; i++) {
    if (bytes <= 1024) {
      return bytes + ' ' + sizes[i]
    } else {
      bytes = parseFloat((bytes / 1024)).toFixed(0)
    }
  }
  return bytes + ' P'
}

export const alphabeticallySort = (array, key) => {
  return array.sort(function (a, b) {
    if (a[key] < b[key]) { return -1 }
    if (a[key] > b[key]) { return 1 }
    return 0
  })
}

export const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

// V14.1
export const stringifyForDUCOutput = (obj) => `___JSON___:${JSON.stringify(obj)}`

// V15.0
export const stringifyForDucOutput = (obj) => {
  if (obj.date && obj.time) {
    return moment(`${obj.date}T${obj.time}`).format('YYYY-MM-DDTHH:mm:ssZ')
  }
  if (obj.date) {
    return obj.date
  }
  if (obj.time) {
    return obj.time
  }
}
